import { IProductInOrder } from 'product/IProduct'
import React from 'react'
import HistoryOrderProductListItem from './HistoryOrderProductListItem'

interface IHistoryOrderProductListProps {
  products: IProductInOrder[]
}

const HistoryOrderProductList: React.FC<IHistoryOrderProductListProps> = ({
  products,
}) => {
  return (
    <>
      {products.map((product) => {
        return <HistoryOrderProductListItem key={product.product_id} product={product} />
      })}
    </>
  )
}
export default HistoryOrderProductList
